import React from 'react';
import { Icon } from 'semantic-ui-react';
import { nth, i18nDescriptionKeys, i18nTitle, published, coupons } from '../../../common/utils';

// https://github.com/react-tools/react-table#columns
export const WORKSHOP_COLS = [
  nth,
  {
    Header: 'Code',
    accessor: 'code',
    maxWidth: 60
  },
  i18nTitle,
  {
    Header: () => <Icon name='calendar' title='Workshop date'/>,
    accessor: 'date',
    maxWidth: 100
  },
  {
    Header: () => <Icon name='clock' ttile='Workshop begin and end time' />,
    id: 'time',
    accessor: 'beginTime',
    maxWidth: 100,
    Cell: ({original: o }) =>  o.beginTime + ' - ' + o.endTime
  },
  {
    Header: () => <Icon name='user times' title='Registered participants/participants limit '/>,
    id: 'users',
    accessor: 'participantCount',
    maxWidth: 60,
    Cell: ({ original: o }) =>
      o.participantCount + '/' + o.participantLimit
  },
  published,
  {
    Header: () => 'Organizer',
    accessor: 'organizer',
    maxWidth: 400
  },
];

export const COMPETITION_COLS = [
  nth,
  {
    Header: 'Code',
    accessor: 'code',
    maxWidth: 60
  },
  i18nTitle,
  {
    Header: () => <Icon name='calendar' title='Event date'/>,
    accessor: 'date',
    maxWidth: 100
  },
  i18nDescriptionKeys,
  {
    Header: () => <Icon name='user times' title='Max. number of team members'/>,
    accessor: 'teamMemberLimit',
    maxWidth: 40
  },
  {
    Header: () => <Icon name='android' title='Robot name is required?'/>,
    accessor: 'event.robotRequired',
    Cell: ({original}) => original.robotRequired ? 'Yes' : 'No',
    maxWidth: 40
  },
  published,
  {
    Header: () => <Icon name='euro sign' title='Price has been defined'/>,
    accessor: 'price',
    Cell: ({ original: { price: p } }) => (!p || !p.length) ? 'N' : 'Y',
    maxWidth: 40
  },
  coupons,
  {
    Header: 'Type',
    accessor: 'competitionType',
    maxWidth: 160
  },
  {
    Header: 'Schedule',
    accessor: 'tournament.hasMatches',
    maxWidth: 120,
    Cell: ({ original: o }) =>  {
      const t = o.tournament || {};

      if (o.competitionType === 'EXTERNAL') {
        return 'N/A';
      } else {
        return t.hasMatches ? 'YES' : '';
      }
    }
  },
  {
    Header: 'Area',
    accessor: 'tournament.area',
    maxWidth: 60
  },
  {
    Header: 'Sector',
    accessor: 'tournament.sector',
    maxWidth: 70
  },
  {
    Header: <Icon name='clock' title='Attempt length in seconds'/>,
    accessor: 'attemptMaxLengthInSeconds',
    maxWidth: 40
  },
  {
    Header: () => <Icon name='users' title='Number of participant competions at the same time'/>,
    accessor: 'concurrentCompetitors',
    maxWidth: 40
  },
  {
    Header: () => <Icon name='numbered list' title='Number of attempts per participant'/>,
    accessor: 'attemptsLimit',
    maxWidth: 40
  },
  {
    Header: () => 'Begin Time',
    accessor: 'tournament.beginTime',
    maxWidth: 100
  },
  {
    Header: () => <Icon name='plus' title='Time offset in minutes'/>,
    accessor: 'tournament.timeOffsetInMinutes',
    maxWidth: 40
  },
  {
    Header: 'Lunch',
    accessor: 'tournament.lunchBeginTime',
    maxWidth: 110,
    Cell: ({ original: { tournament: t} }) => {
      if (t && t.lunchBeginTime) {
        return t.lunchBeginTime + ' - ' + t.lunchEndTime;
      }

      return '';
    }
  }
];

export const DEFAULTSORTED = [
  { id: 'event.title', desc: true },
  { id: 'title', desc: true }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competitions/table.conf.js